import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from "./contexts/AuthContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import ArticlePage from "./pages/ArticlePage";
import CategoryPage from "./pages/CategoryPage";
import SearchPage from "./pages/SearchPage";
import SubmitStoryPage from "./pages/SubmitStoryPage";
import NewsletterPage from "./pages/NewsletterPage";
import MediaAlertPage from "./pages/MediaAlertPage";
import ReviewArticlePage from "./pages/ReviewArticlePage";
import ShareGoodNewsPage from "./pages/ShareGoodNewsPage";
import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";
import DashboardPage from "./pages/DashboardPage";
import ProfilePage from "./pages/ProfilePage";
import AuthorPage from "./pages/AuthorPage";
import AdminDashboard from "./pages/AdminDashboard";
import EditArticlePage from "./pages/EditArticlePage";
import CreateArticle from "./pages/CreateArticle";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import JournalistProfilePage from "./pages/JournalistProfilePage";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <div className="App min-h-screen flex flex-col">
        <BrowserRouter>
          <Header />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/article/:slug" element={<ArticlePage />} />
              <Route path="/category/:slug" element={<CategoryPage />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/submit-story" element={<SubmitStoryPage />} />
              <Route path="/newsletter" element={<NewsletterPage />} />
              <Route path="/media-alerts" element={<MediaAlertPage />} />
              <Route path="/review-article/:responseId" element={<ReviewArticlePage />} />
              <Route path="/share-good-news" element={<ShareGoodNewsPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/signup" element={<SignupPage />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/author/:authorName" element={<AuthorPage />} />
              <Route path="/journalist/:username" element={<JournalistProfilePage />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/create-article" element={<CreateArticle />} />
              <Route path="/admin/edit-article/:articleId" element={<EditArticlePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
            </Routes>
          </main>
          <Footer />
          <Toaster />
        </BrowserRouter>
      </div>
    </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
